import React, {useState, useEffect} from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ServiceArticleSection from "./ServiceArticleSection";
import { useParams, useNavigate } from "react-router-dom";
import services from "../Services/services.json";

const ServiceArticle = () => {
    const [articleInfo, setArticleInfo] = useState({});
    const {article} = useParams();
    const navigate = useNavigate();
    useEffect(() => {
      if (services.services.filter(e => e.url === article).length > 0) {
        setArticleInfo(services.services.find(x => x.url === article));
      }else{
        navigate("/error");
      }
    }, [])
    
  return (
    <>
      <Navbar />
      <ServiceArticleSection articleInfo={articleInfo} />
      <Footer />
    </>
  );
};

export default ServiceArticle;